import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { getSpaceList, setSpaceList, getLastUpdated, setLastUpdated } from "../store";
import { SpaceModel } from "../interfaces/Space";
import { Metadata } from "../interfaces/Metadata";

const spacesUrl = `${process.env.REACT_APP_API_URL}/spaces`;
const metadataUrl = `${process.env.REACT_APP_API_URL}/spaces/metadata`;


export default function UseSpaceListFetch() {

    const [spaces, setSpaces] = useState<SpaceModel[]>([]);
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);


    const doSpacesRequest = async (): Promise<SpaceModel[]> => {
        const { data } = await axios.get<SpaceModel[]>(spacesUrl, { withCredentials: true });
        return data;
    }

    const doMetadataRequest = async (): Promise<Metadata> => {
        try {
            const { data } = await axios.get<Metadata>(metadataUrl, { withCredentials: true })
            return data;
        } catch (err) {
            console.warn(`request for metadata failed: ${err}`);
            return { lastUpdated: 0 };
        }
    };

    const getSpaces = useCallback(async (): Promise<void> => {
        try {
            const storeData = getSpaceList();
            const lastUpdated = getLastUpdated();
            const metadata = await doMetadataRequest();

            //if last updated doesn't match client memory, do the request
            if (lastUpdated !== metadata.lastUpdated || !storeData || storeData.length <= 0) {
                const data = await doSpacesRequest();
                setTimeout(() => {
                    setSpaces(data);
                    setSpaceList(data);
                    setLastUpdated(metadata.lastUpdated);
                }, 100)
            } else {
                setSpaces(storeData);
            }

        } catch (err: any) {
            console.warn(err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getSpaces();
    }, [getSpaces])

    return { spaces, error, loading }
}